import verify from '@/assets/verify-icon.svg'
import email from '@/assets/email-icon.svg'
import gift from '@/assets/gift-icon.svg'
import warning from '@/assets/warning-circle-icon.svg'
import warningYellow from '@/assets/warning-circle-icon-yellow.svg'
import mobileOtp from '@/assets/mobile-otp-icon.svg'
import mobilePhone from '@/assets/mobile-phone-icon.svg'
import checkedOutline from '@/assets/checked-outline.svg'
import iconPhone from '@/assets/icon-phone.svg'
import iconDuplicatePassport from '@/assets/icon-duplicate-passport.svg'
import laserInfo from '@/assets/id-card-back-info.svg'
import birthdateTh from '@/assets/birthdate-th-icon.svg'
import birthdateNonthai from '@/assets/birthdate-non-th-icon.svg'
import address from '@/assets/address-icon.svg'
import shield from '@/assets/shield.svg'
import expand from '@/assets/expand-icon.svg'
import nonExpand from '@/assets/non-expand-icon.svg'
import thFlag from '@/assets/th-flag.svg'
import enFlag from '@/assets/en-flag.svg'
import myFlag from '@/assets/my-flag.svg'
import khFlag from '@/assets/kh-flag.svg'
import loFlag from '@/assets/lo-flag.svg'
import cnFlag from '@/assets/cn-flag.svg'
import ruFlag from '@/assets/ru-flag.svg'
import iconIdCardReader from '@/assets/icon-id-card-reader.svg'
import iconInsertIdCard from '@/assets/icon-insert-id-card.svg'
import forgotMobile from '@/assets/forgot-mobile.svg'
import maintainance from '@/assets/maintainance.svg'

export const icons = {
  verify,
  email,
  gift,
  warning,
  warningYellow,
  mobileOtp,
  mobilePhone,
  checkedOutline,
  iconPhone,
  iconDuplicatePassport,
  laserInfo,
  birthdateTh,
  birthdateNonthai,
  address,
  shield,
  expand,
  nonExpand,
  iconIdCardReader,
  iconInsertIdCard,
  forgotMobile,
  maintainance
}

export const flagIcons = {
  thFlag,
  enFlag,
  myFlag,
  khFlag,
  loFlag,
  cnFlag,
  ruFlag,
}

export type IconName = keyof typeof icons
export type FlagIconName = keyof typeof flagIcons
